<template>
  <el-dropdown :trigger="triggerType" :class="additionalClasses">
    <span class="el-dropdown-link">
      <button class="btn btn-notify">
        <i class="icon-bell"></i>
        <div class="counter" v-if="readed_count">
          {{ readed_count }}
        </div>
      </button>
    </span>
    <template #dropdown>
      <el-dropdown-menu class="el-dropdown-notifications">
        <h6 class="fw-bold ps-3 pt-2">Notificações</h6>
        <el-dropdown-item v-if="notifications.length == 0">
          Sem notificações no momento
        </el-dropdown-item>

        <el-dropdown-item
          class="el-dropdown-links"
          @click="setReadNotification(notification)"
          v-for="notification in notifications"
          :key="notification.id"
        >
          <notification-item
            :item="notification"
            :is-readed="isReaded(notification)"
          />
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>
<script>
  import NotificationItem from "@/components/notifications/NotificationItem";
  import { mapState } from "vuex";

  export default {
    components: { NotificationItem },
    props: ["additionalClasses"],
    mounted() {
      this.$store.dispatch("notifications/getAll").then();
    },
    computed: {
      ...mapState("notifications", ["notifications"]),
      readed_count() {
        let stringNotify = localStorage.getItem("notifications");

        let notifications = stringNotify && JSON.parse(stringNotify);

        if (!notifications || notifications.length == 0) {
          return this.notifications.length;
        }

        let readed = 0;
        this.notifications.map((notification) => {
          if (notifications.find((item) => item.id == notification.id)) {
            readed++;
          }
        });

        return this.notifications.length - readed;
      },
      triggerType() {
        if (window.innerWidth > 992) {
          return "hover";
        } else {
          return "click";
        }
      },
    },
    methods: {
      isReaded(notification) {
        let stringNotify = localStorage.getItem("notifications");
        let notifications = stringNotify && JSON.parse(stringNotify);
        if (!notifications || notifications.length == 0) {
          return false;
        }

        return notifications.find((item) => item.id == notification.id);
      },
      setReadNotification(notification) {
        let stringNotify = localStorage.getItem("notifications");
        let notifications = stringNotify && JSON.parse(stringNotify);
        if (notifications && notifications.length != 0) {
          // push here
          let exist = notifications.find((item) => item.id == notification.id);
          if (!exist) {
            notifications.push(notification);
          }
          localStorage.setItem("notifications", JSON.stringify(notifications));
        } else {
          localStorage.setItem("notifications", JSON.stringify([notification]));
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .el-dropdown-notifications {
    background-color: #000;
    border: 1px solid transparent;
    max-height: 50vh;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    @media screen and (max-width: 991px) {
      margin-top: 1rem;
    }

    :deep(.el-dropdown-menu__item) {
      color: white;
      &:hover {
        background-color: #000 !important;
      }
    }

    .el-dropdown-links {
      @media screen and (max-width: 768px) {
        width: 70%;
      }
    }
  }
</style>
